export default "__VITE_ASSET__DKZmOKTZ__"